import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const MiniLoader = ({color,size}) => {
  return (
    <CircularProgress disableShrink color={color} size={size ?? 10}  />
  )
}

export default MiniLoader;